import React, { useState, useCallback } from 'react';
function Keybord({ name, onChange }) {
  const setString = useCallback(
    (str) => {
      let char;
      let _name;
      // 削除
      if (str == 'back') {
        if (name.length > 0) {
          onChange(name.substring(0, name.length - 1));
        }
        return;
      }

      // 濁点
      if (str == 'dakuten') {
        if (name.length > 0) {
          char = name.substring(name.length - 1, name.length);
          _name = name.substring(0, name.length - 1);
          onChange(_name + convertChar(char, 1));
        }
        return;
      }

      // 半濁点
      if (str == 'handaku') {
        if (name.length > 0) {
          char = name.substring(name.length - 1, name.length);
          _name = name.substring(0, name.length - 1);
          onChange(_name + convertChar(char, 2));
        }
        return;
      }

      // 小文字
      if (str == 'komoji') {
        if (name.length > 0) {
          char = name.substring(name.length - 1, name.length);
          _name = name.substring(0, name.length - 1);
          onChange(_name + convertChar(char, 3));
        }
        return;
      }

      onChange(name + str);
    },
    [name]
  );

  return (
    <div className="tableKeybord" onClick={(e) => e.stopPropagation()}>
      <div className="col-dropdown">
        <div className="key" onTouchStart={() => {}} onClick={() => setString('あ')}>
          あ
        </div>
        <div className="dropdown-content">
          <div className="key" onTouchStart={() => {}} onClick={() => setString('い')}>
            い
          </div>
          <div className="key" onTouchStart={() => {}} onClick={() => setString('う')}>
            う
          </div>
          <div className="key" onTouchStart={() => {}} onClick={() => setString('え')}>
            え
          </div>
          <div className="key" onTouchStart={() => {}} onClick={() => setString('お')}>
            お
          </div>
        </div>
      </div>
      <div className="col-dropdown">
        <div className="key" onTouchStart={() => {}} onClick={() => setString('か')}>
          か
        </div>
        <div className="dropdown-content">
          <div className="key" onTouchStart={() => {}} onClick={() => setString('き')}>
            き
          </div>
          <div className="key" onTouchStart={() => {}} onClick={() => setString('く')}>
            く
          </div>
          <div className="key" onTouchStart={() => {}} onClick={() => setString('け')}>
            け
          </div>
          <div className="key" onTouchStart={() => {}} onClick={() => setString('こ')}>
            こ
          </div>
        </div>
      </div>
      <div className="col-dropdown">
        <div className="key" onTouchStart={() => {}} onClick={() => setString('さ')}>
          さ
        </div>
        <div className="dropdown-content">
          <div className="key" onTouchStart={() => {}} onClick={() => setString('し')}>
            し
          </div>
          <div className="key" onTouchStart={() => {}} onClick={() => setString('す')}>
            す
          </div>
          <div className="key" onTouchStart={() => {}} onClick={() => setString('せ')}>
            せ
          </div>
          <div className="key" onTouchStart={() => {}} onClick={() => setString('そ')}>
            そ
          </div>
        </div>
      </div>
      <div className="col-dropdown">
        <div className="key" onTouchStart={() => {}} onClick={() => setString('た')}>
          た
        </div>
        <div className="dropdown-content">
          <div className="key" onTouchStart={() => {}} onClick={() => setString('ち')}>
            ち
          </div>
          <div className="key" onTouchStart={() => {}} onClick={() => setString('つ')}>
            つ
          </div>
          <div className="key" onTouchStart={() => {}} onClick={() => setString('て')}>
            て
          </div>
          <div className="key" onTouchStart={() => {}} onClick={() => setString('と')}>
            と
          </div>
        </div>
      </div>
      <div className="col-dropdown">
        <div className="key" onTouchStart={() => {}} onClick={() => setString('な')}>
          な
        </div>
        <div className="dropdown-content">
          <div className="key" onTouchStart={() => {}} onClick={() => setString('に')}>
            に
          </div>
          <div className="key" onTouchStart={() => {}} onClick={() => setString('ぬ')}>
            ぬ
          </div>
          <div className="key" onTouchStart={() => {}} onClick={() => setString('ね')}>
            ね
          </div>
          <div className="key" onTouchStart={() => {}} onClick={() => setString('の')}>
            の
          </div>
        </div>
      </div>
      <div className="col-dropdown">
        <div className="key" onTouchStart={() => {}} onClick={() => setString('は')}>
          は
        </div>
        <div className="dropdown-content">
          <div className="key" onTouchStart={() => {}} onClick={() => setString('ひ')}>
            ひ
          </div>
          <div className="key" onTouchStart={() => {}} onClick={() => setString('ふ')}>
            ふ
          </div>
          <div className="key" onTouchStart={() => {}} onClick={() => setString('へ')}>
            へ
          </div>
          <div className="key" onTouchStart={() => {}} onClick={() => setString('ほ')}>
            ほ
          </div>
        </div>
      </div>
      <div className="col-dropdown">
        <div className="key" onTouchStart={() => {}} onClick={() => setString('ま')}>
          ま
        </div>
        <div className="dropdown-content">
          <div className="key" onTouchStart={() => {}} onClick={() => setString('み')}>
            み
          </div>
          <div className="key" onTouchStart={() => {}} onClick={() => setString('む')}>
            む
          </div>
          <div className="key" onTouchStart={() => {}} onClick={() => setString('め')}>
            め
          </div>
          <div className="key" onTouchStart={() => {}} onClick={() => setString('も')}>
            も
          </div>
        </div>
      </div>
      <div className="col-dropdown">
        <div className="key" onTouchStart={() => {}} onClick={() => setString('や')}>
          や
        </div>
        <div className="dropdown-content">
          <div className="key" onTouchStart={() => {}} onClick={() => setString('ゆ')}>
            ゆ
          </div>
          <div className="key" onTouchStart={() => {}} onClick={() => setString('よ')}>
            よ
          </div>
        </div>
      </div>
      <div className="col-dropdown">
        <div className="key" onTouchStart={() => {}} onClick={() => setString('ら')}>
          ら
        </div>
        <div className="dropdown-content">
          <div className="key" onTouchStart={() => {}} onClick={() => setString('り')}>
            り
          </div>
          <div className="key" onTouchStart={() => {}} onClick={() => setString('る')}>
            る
          </div>
          <div className="key" onTouchStart={() => {}} onClick={() => setString('れ')}>
            れ
          </div>
          <div className="key" onTouchStart={() => {}} onClick={() => setString('ろ')}>
            ろ
          </div>
        </div>
      </div>
      <div className="col-dropdown">
        <div className="key" onTouchStart={() => {}} onClick={() => setString('わ')}>
          わ
        </div>
        <div className="dropdown-content">
          <div className="key" onTouchStart={() => {}} onClick={() => setString('を')}>
            を
          </div>
          <div className="key" onTouchStart={() => {}} onClick={() => setString('ん')}>
            ん
          </div>
        </div>
      </div>
      <div className="col-dropdown">
        <div className="key" onTouchStart={() => {}} onClick={() => setString('ー')}>
          ー
        </div>
      </div>
      <div className="col-dropdown">
        <div onTouchStart={() => {}} onClick={() => setString('dakuten')} className="key">
          ゛
        </div>
      </div>
      <div className="col-dropdown">
        <div onTouchStart={() => {}} onClick={() => setString('handaku')} className="key">
          ゜
        </div>
      </div>
      <div className="col-dropdown">
        <div onTouchStart={() => {}} onClick={() => setString('komoji')} className="key">
          小
        </div>
      </div>
      <div className="col-dropdown">
        <div onTouchStart={() => {}} onClick={() => setString('back')} className="key">
          ←
        </div>
      </div>
    </div>
  );
}

export default Keybord;

/**
 * 濁点、半濁点に変換
 */
function convertChar(str, mode) {
  const voiced_list = {
    か: ['か', 'が'],
    き: ['き', 'ぎ'],
    く: ['く', 'ぐ'],
    け: ['け', 'げ'],
    こ: ['こ', 'ご'],
    さ: ['さ', 'ざ'],
    し: ['し', 'じ'],
    す: ['す', 'ず'],
    せ: ['せ', 'ぜ'],
    そ: ['そ', 'ぞ'],
    た: ['た', 'だ'],
    ち: ['ち', 'ぢ'],
    つ: ['つ', 'づ'],
    て: ['て', 'で'],
    と: ['と', 'ど'],
    は: ['は', 'ば', 'ぱ'],
    ひ: ['ひ', 'び', 'ぴ'],
    ふ: ['ふ', 'ぶ', 'ぷ'],
    へ: ['へ', 'べ', 'ぺ'],
    ほ: ['ほ', 'ぼ', 'ぽ'],
  };

  const lower_case = {
    あ: ['あ', 'ぁ'],
    い: ['い', 'ぃ'],
    う: ['う', 'ぅ'],
    え: ['え', 'ぇ'],
    お: ['お', 'ぉ'],
    つ: ['つ', 'っ'],
    や: ['や', 'ゃ'],
    ゆ: ['ゆ', 'ゅ'],
    よ: ['よ', 'ょ'],
    わ: ['わ', 'ゎ'],
  };
  if (mode == 3) {
    for (var item in lower_case) {
      var hira = lower_case[item][0];
      var lowe = lower_case[item][1];

      if (str == hira) {
        return lowe;
      } else if (str == lowe) {
        return hira;
      }
    }
  } else {
    for (var item in voiced_list) {
      var hira = voiced_list[item][0];
      var daku = voiced_list[item][1];
      var hann = '';
      if (voiced_list[item][2]) {
        hann = voiced_list[item][2];
      }

      if ((str == hira || str == hann) && mode == 1) {
        return daku;
      } else if ((str == hira || str == daku) && mode == 2) {
        return hann;
      } else if (str == daku || str == hann) {
        return hira;
      }
    }
  }
  return str;
}
